import { Vorversicherung, VorversicherungsItem } from '../model/vorversicherung';
import { StatePreV25, StateV25 } from './25_migrate_vorversicherer_allianz.interface';

const LEGACY_ANSTALTSNR = 'ACY';
const CURRENT_ANSTALTSNR = 'AF7';

const migrateVorversicherungsItem = (item: VorversicherungsItem): VorversicherungsItem =>
  item.versicherungsgesellschaft === LEGACY_ANSTALTSNR
    ? { ...item, versicherungsgesellschaft: CURRENT_ANSTALTSNR }
    : item;

const migrateVorversicherung = (vorversicherung: Vorversicherung): Vorversicherung => ({
  ...vorversicherung,
  vorversicherungsListe: (vorversicherung.vorversicherungsListe ?? []).map(
    migrateVorversicherungsItem,
  ),
});

export const migrateVorversichererAllianz = (
  previousState: StatePreV25,
  newVersion: number,
): StateV25 => ({
  ...previousState,
  version: newVersion,
  vorversicherungen: (previousState.vorversicherungen ?? []).map(migrateVorversicherung),
});
